import React from 'react'

import { MdlCommaIcon } from '../../assets/Icon'
import FeedBackCard from '../../components/FeedBackCard'
import SectionContent from '../../components/SectionContent'
import SectionHeader from '../../components/SectionHeader'
import SectionLayout from '../../components/SectionLayout'
import { feedBackData } from '../../data/feedBackSection'

const FeedBackSection = () => {
  return (
    <SectionLayout>
      <SectionHeader className="text-4xl sm:text-5xl py-5 flex items-center justify-center">
        <div className="relative">
          <span className="hidden sm:flex absolute flex-row -left-16 -top-5">
            <MdlCommaIcon className="w-10 h-10" />
            <MdlCommaIcon className="w-10 h-10 -translate-x-3.5" />
          </span>
          What does our student say about us ?
        </div>
      </SectionHeader>
      <SectionContent>
        {feedBackData.map(({ id, ...rest }) => (
          <FeedBackCard key={id} {...rest} />
        ))}
      </SectionContent>
    </SectionLayout>
  )
}

export default FeedBackSection
